/**
 * Privilege names already covered by static SideMenu / routesForm.
 * API items with these privileges are excluded from dynamic append.
 */
export const STATIC_MODULE_PRIVILEGES = new Set([
  "view_admin_center_reports",
  "operate_uam",
  "operate_cm",
  "view_audit",
  "view_notifications",
  "view_workflow_manager",
  "view_knowledge_manager",
  "view_process_manager",
  "operate_event_manager",
  "operate_docs_manager",
  "view_ui_manager",
  "view_archive_manager",
  "admin-center-view-plan-and-automation",
]);

/**
 * Static top-level SPA route paths used for dynamic route / menu dedup
 * (compared against `/${module.name}`, not API `path`).
 */
export const STATIC_MODULE_ROUTE_PATHS = new Set([
  "/reports",
  "/user-access-management",
  "/configuration",
  "/audit",
  "/notifications",
  "/workflow-manager",
  "/knowledge-manager",
  "/bpmn",
  "/event-manager",
  "/docs-manager",
  "/uimanager",
  "/archivemanager",
  "/plan-and-automation",
]);

/** @deprecated Use STATIC_MODULE_ROUTE_PATHS */
export const STATIC_MODULE_PATHS = STATIC_MODULE_ROUTE_PATHS;

/**
 * Extra parentName layers for getRelatedMenuResourceList beyond
 * root (parentId: 0) and view_admin_center.
 */
export const AC_MENU_EXPAND_PARENT_NAMES = [
  "operate_uam",
  "view_process_manager",
] as const;
